var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9714 4.47138C13.2317 4.21103 13.2317 3.78892 12.9714 3.52858C12.711 3.26823 12.2889 3.26823 12.0286 3.52858L8.49998 7.05717L4.97138 3.52858C4.71103 3.26823 4.28892 3.26823 4.02858 3.52858C3.76823 3.78892 3.76823 4.21103 4.02858 4.47138L7.55717 7.99998L4.02858 11.5286C3.76823 11.7889 3.76823 12.211 4.02858 12.4714C4.28892 12.7317 4.71103 12.7317 4.97138 12.4714L8.49998 8.94279L12.0286 12.4714C12.2889 12.7317 12.711 12.7317 12.9714 12.4714C13.2317 12.211 13.2317 11.7889 12.9714 11.5286L9.44279 7.99998L12.9714 4.47138Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelCrossIcon);
export default __webpack_public_path__ + "static/media/del-cross-icon.586f299b76b2fbe8c83c81e843ef9bc5.svg";
export { ForwardRef as ReactComponent };